import React, { useContext } from 'react';
import { IconButton, Typography } from '@mui/material';
import ReferencialContext from 'Shared/ReferencialContext';
import SettingsIcon from '@mui/icons-material/Settings';
/* eslint-disable import/prefer-default-export */
const TitleStyle = {
  fontSize: '12px',
  fontWeight: 500,
  borderBottom: 'none',
  textTransform: 'uppercase',
  background: '#e4e7ea',
  font: 'normal normal 600 10px Montserrat',
  letterSpacing: 0,
  color: '#707070',
  padding: '16px 8px',
};
const defaultColumnStyle = {
  font: 'normal normal 600 14px Montserrat',
  letterSpacing: 0,
  color: '#38485C',
  marginLeft: 5,
};
export const columns = [
  {
    id: 'reference',
    label: 'Réference',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>{value}</Typography>
    ),
  },
  {
    id: 'des',
    label: 'Désignation',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'fId',
    label: 'Famille',
    style: TitleStyle,
    render: ({ value }) => {
      const {
        state: {
          referencial: { families },
        },
      } = useContext(ReferencialContext);
      return (
        <Typography sx={defaultColumnStyle}>
          {value && families.find((f) => value === f.id)?.name}
        </Typography>
      );
    },
  },
  {
    id: 'bId',
    label: 'Marque',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'p',
    label: 'Prix',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'r',
    label: 'Remise',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'sB',
    label: 'Stock BO',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'sD',
    label: 'Stock DO',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'action',
    label: 'Action',
    style: TitleStyle,
    render: ({ row }) => (
      <IconButton
        onClick={row.navigateSettings}
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: 12,
        }}
      >
        <SettingsIcon />
      </IconButton>
    ),
  },
];
